import { render, staticRenderFns } from "./ddt_listpage.vue?vue&type=template&id=65c174b8&"
import script from "./ddt_listpage.vue?vue&type=script&lang=js&"
export * from "./ddt_listpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports